import React from "react";
import { BookOpenIcon, CheckIcon, GiftIcon, GlobeIcon, TrophyIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images } from "../../data/landing";
const perks = ["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees", "7-day guarantee"];
export function Offer() {
  return <section id="offer" className="bg-navy px-4 py-16 sm:py-24" data-id="element-207" data-mp="3a4xefo0zp2ji">
      <div className="mx-auto max-w-2xl" data-id="element-208" data-mp="3f3qiyqyatj7j">
        <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-gold" data-id="element-209" data-mp="3f2p8oop3x0qv">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-210" data-mp="3jxmfdoywyy0l" />
          Special launch offer
        </p>
        <h2 className="mt-3 text-center font-serif text-[1.9rem] font-extrabold leading-[1.12] text-white sm:text-5xl" data-id="element-211" data-mp="3svydec240y32">
          Here's everything you'll receive today
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-gold bg-white" data-id="element-212" data-mp="1nj6hsfn4o8t">
          <img src={images.mockup} alt="Complete Lipo Planning Workbook system" className="w-full bg-cream" loading="lazy" data-id="element-213" data-mp="1kmrmcbwyz67a" />
          <div className="p-6 sm:p-8" data-id="element-214" data-mp="1bks8ttl5yk93">
            <ul className="divide-y divide-navy/10" data-id="element-215" data-mp="1blth5qasosn4">
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-216" data-mp="16lp0o09vzxww">
                <span className="flex items-start gap-3" data-id="element-217" data-mp="16njq9rw3se7b">
                  <BookOpenIcon className="mt-0.5 h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-218" data-mp="23c7u9kazi0xq" />
                  <span data-id="element-219" data-mp="1zbfgqev2x9vn">
                    <strong className="block text-navy" data-id="element-220" data-mp="1zb621nfhip59">Lipo Planning Workbook™</strong>
                    <span className="text-sm text-navy/65" data-id="element-221" data-mp="1uicukrsmt2ph">6 premium volumes</span>
                  </span>
                </span>
                <span className="shrink-0 font-bold text-navy/50 line-through" data-id="element-222" data-mp="1pigpsqc4178v">$97</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-223" data-mp="2n1s0qo3lmx2l">
                <span className="flex items-start gap-3" data-id="element-224" data-mp="2i7xilp3n6q5m">
                  <GiftIcon className="mt-0.5 h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-225" data-mp="3157fakc7vepe" />
                  <span data-id="element-226" data-mp="364ts4so4usxo">
                    <strong className="block text-navy" data-id="element-227" data-mp="36427gcw2qfm6">5 exclusive bonuses</strong>
                    <span className="text-sm text-navy/65" data-id="element-228" data-mp="2sc41gaxnszu8">+ 30+ planning tools</span>
                  </span>
                </span>
                <span className="shrink-0 font-bold text-navy/50 line-through" data-id="element-229" data-mp="2wco0jk1smdj0">$197</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-230" data-mp="2ihc7dh3acv47">
                <span className="font-bold uppercase tracking-wide text-navy" data-id="element-231" data-mp="2nfne3iyaapi7">Total perceived value</span>
                <span className="shrink-0 text-lg font-extrabold text-red-600 line-through" data-id="element-232" data-mp="29g47iul4fm80">$294</span>
              </li>
            </ul>

            <div className="mt-4 rounded-2xl bg-cream px-5 py-7 text-center" data-id="element-233" data-mp="7n7qmr4j5pfz">
              <p className="text-[16px] text-navy/80" data-id="element-234" data-mp="7l3p2fu3t2iv">Today, get the complete system for only…</p>
              <p className="mt-1 font-serif text-[5.5rem] font-extrabold leading-none text-cta sm:text-8xl" data-id="element-235" data-mp="bm74504buuj1">$27</p>
              <p className="mt-2 text-sm font-extrabold uppercase tracking-[0.2em] text-navy" data-id="element-236" data-mp="1s4yy3kqyxnc3">One-time payment</p>
              <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-navy-50 px-3 py-2.5 text-sm font-semibold text-navy" data-id="element-237" data-mp="25wx4vox7j753">
                <GlobeIcon className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-238" data-mp="213kf3bgskuar" />
                Currency conversion is automatic according to your country.
              </p>
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-239" data-mp="2axkrzzibf3u1">
              {perks.map(p => <li key={p} className="flex items-center gap-2.5 text-[16px] font-medium text-ink" data-id="element-240" data-mp="2ot59cqiebdzc">
                  <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-241" data-mp="2ju28zjdd1vxp" />
                  {p}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-242" data-mp="pjfa6030561w">
              <CtaButton label="Get Lipo Planning Workbook™ for $27" note="Secure checkout · Instant digital access · 7-day guarantee" data-id="element-243" data-mp="pki1280br8ht" />
            </div>

            <div className="mt-8 flex flex-col items-center gap-5" data-id="element-244" data-mp="vxcjy2j4t82l">
              <Countdown data-id="element-245" data-mp="10xqhgqn3wzmd" />
              <ScarcityBar spotsText="at $27" data-id="element-246" data-mp="10yidg2km8zd6" />
            </div>
          </div>
        </div>

        <p className="mt-6 text-center text-[16px] leading-relaxed text-white/75" data-id="element-247" data-mp="15wtj013vonpl">
          For less than the cost of many professional educational resources, you'll have a structured case-planning system you
          can return to whenever you study a liposuction case.
        </p>
      </div>
    </section>;
}